import { useCallback } from 'react';
import { RoommateSelection, RoommateSelectionConfirmation } from '@common/validation-schemas';
import { post } from 'config/api/config';
import { useRoommateSelectionConfirmation } from 'providers/RoommateSelectionConfirmationProvider';

export function useConfirmRoommateSelectionChange() {
  const confirm = useRoommateSelectionConfirmation();
  return useCallback(
    async (
      responseId: string,
      pageId: string,
      selection: RoommateSelection,
    ): Promise<RoommateSelectionConfirmation | false | undefined> => {
      const response = await post(
        `/viewer/responses/${responseId}/roommate-selection-change/preview`,
        { selection },
      );
      if (!response.data.confirmationRequired) return response.data.confirmation;
      return (await confirm(pageId)) ? response.data.confirmation : false;
    },
    [confirm],
  );
}
